import { Injectable } from '@angular/core';

import { Observable, of, Subject } from 'rxjs';
import { first, switchMap } from 'rxjs/operators';
import { AlertService } from '@shared';
import { TranslateService } from '@ngx-translate/core';
import { UnsavedChangesService } from '../services';

@Injectable()
export class FormDeactivateGuard {
	private isModalOpened = false;
	public constructor(
		private alertService: AlertService,
		private translateService: TranslateService,
		private unsavedChangesService: UnsavedChangesService
	) {}

	public canDeactivate(): Observable<boolean> {
		return this.unsavedChangesService.hasChanges$.pipe(
			first(),
			switchMap((hasUnsavedChanges: boolean) => {
				const alertSubject = new Subject<boolean>();
				if (hasUnsavedChanges && !this.isModalOpened) {
					const cancelButton = {
						text: this.translateService.instant('alert.buttons.cancel'),
						handler: () => {
							this.isModalOpened = false;
							alertSubject.next(false);
						}
					};

					const confirmButton = {
						text: this.translateService.instant('alert.buttons.exit'),
						handler: () => {
							alertSubject.next(true);
							this.isModalOpened = false;
						}
					};
					this.isModalOpened = true;
					this.alertService.presentAlert(
						this.translateService.instant('alert.message'),
						[cancelButton, confirmButton],
						false
					);

					return alertSubject;
				}

				return of(true);
			})
		);
	}
}
